import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '../lib/api'
import type { Notificacao, NotificacaoContagem, PaginatedResponse } from '../types'

interface NotificacaoListParams {
  lida?: boolean
  nivel?: 'info' | 'warning' | 'critical'
  tipo?: string
}

export function useNotificacaoList(params?: NotificacaoListParams) {
  return useQuery({
    queryKey: ['notificacoes', params],
    queryFn: async () => {
      const r = await api.get<PaginatedResponse<Notificacao>>('/notificacoes/', {
        params: {
          ...(params?.lida !== undefined ? { lida: String(params.lida) } : {}),
          ...(params?.nivel ? { nivel: params.nivel } : {}),
          ...(params?.tipo ? { tipo: params.tipo } : {}),
        },
      })
      return r.data
    },
    staleTime: 1000 * 30,
  })
}

export function useNotificacaoContagem() {
  return useQuery({
    queryKey: ['notificacoes', 'contagem'],
    queryFn: async () => {
      const r = await api.get<NotificacaoContagem>('/notificacoes/contagem/')
      return r.data
    },
    staleTime: 1000 * 30,
    refetchInterval: 1000 * 60, // poll a cada 60s
  })
}

export function useNotificacaoMarcarLida(id: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => api.patch(`/notificacoes/${id}/marcar-lida/`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['notificacoes'] })
    },
  })
}

export function useNotificacaoMarcarTodasLidas() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => api.post('/notificacoes/marcar-todas-lidas/'),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notificacoes'] }),
  })
}
